import { render, staticRenderFns } from "./FormOperasi.vue?vue&type=template&id=0889ffca&"
import script from "./FormOperasi.vue?vue&type=script&lang=js&"
export * from "./FormOperasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports